//Margin conventions
		var margin = {top:20, right: 10, bottom: 20, left: 2};
		var widther = d3.select(".gia-chart").node().clientWidth;
		var width = widther - margin.left - margin.right,
		    height = 300 - margin.top - margin.bottom;

		//Parses date for correct time format
		var parseDate = d3.time.format("%Y-%m").parse; 

		//Appends the svg to the chart-container div
		var svg = d3.select(".gia-chart").append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		//Creates the xScale 
			var xScale = d3.scale.ordinal()
				.rangeRoundBands([0, width], .25);

			//Creates the yScale
			var yScale = d3.scale.linear()
				.range([height, 0]);

			//Defines the y axis styles
			var yAxis = d3.svg.axis()
				.scale(yScale)
				.tickSize(-width)
				.tickPadding(8)
				.tickFormat(function(d) { return d + "%"; })
				.orient("left"); 

		//Loads the data
		d3.csv("data/climateconcerns.csv", ready);

		function ready(err, data) {
			if (err) throw "error loading data";

			//FORMAT data
			data.forEach(function(d) {
				d.total = +d.total;
		    	d.date = parseDate(d.date);
			});

		  	//Sets min and max on xScale
		  	var xMin = d3.min(data, function(d) { return d.date;});
		  	var xMax = d3.max(data, function(d) { return d.date;});
		  	var yMin = d3.min(data, function(d) { return d.total;});
		  	var yMax = d3.max(data, function(d) { return d.total;});

  			//Sets scale domains
  			xScale.domain(data.map(function(d) { return d.date; }));
  			yScale.domain([0, 80]);

  			//Defines the x axis styles
  			var xAxis = d3.svg.axis()
  			  	.scale(xScale)
  			  	.tickSize(height)
  			  	.tickPadding(8)
  			  	.tickValues(xScale.domain().filter(function(d, i) {
  			  		if(d3.select(".gia-chart").node().clientWidth > 410) {
  			  			return !(i % 2);
  			  		}
  			  		else {
  			  			return !(i % 4);
  			  		}
  			  	}))
  			  	.orient("bottom")
  			  	.tickFormat(d3.time.format("%b-%y")); 
			
  			//Binds the data to the bars      
  			var bar = svg.selectAll(".bar")
  			  	.data(data)
  			  	.enter()
  			  	.append("rect")
  			  	.attr("class", "bar")
  			  	.attr("x", function(d) { return xScale(d.date); })
  			  	.attr("width", xScale.rangeBand() - 5)
  			  	.attr("y", function(d) { return yScale(d.total); })
  			  	.attr("height", function(d) { return height - yScale(d.total); })
  			  	.attr("transform", "translate(15, 0)");  

  			var secondbar = svg.selectAll(".secondbar")
  			  	.data(data)
  			  	.enter()
  			  	.append("rect")
  			  	.attr("class", "secondbar")
  			  	.attr("x", function(d) { return xScale(d.date); })
  			  	.attr("width", xScale.rangeBand() - 5)
  			  	.attr("y", function(d) { return yScale(d.vworried); })
  			  	.attr("height", function(d) { return height - yScale(d.vworried); })
  			  	.attr("transform", "translate(15, 0)");  	
			
  			//Appends the y axis
			var yAxisGroup = svg.append("g")
				.attr("class", "y axis")
				.call(yAxis)
    			.selectAll("g")
    			.classed("g-baseline", function(d) { return d == 0 });

    		d3.selectAll(".y.axis text")
    		  	.attr("transform", "translate(7, -10)");	

			//Appends the x axis		
			var xAxisGroup = svg.append("g")
				.attr("class", "x axis")
				.call(xAxis);

			d3.selectAll(".x.axis text")
			  	.attr("transform", "translate(12, 0)");		
  		
  			//RESPONSIVENESS
  			d3.select(window).on("resize", resized);
  			
  			function resized() {

			//new margin
    			var newMargin = {top:20, right: 10, bottom: 20, left: 2};

    			var newWidther = d3.select(".gia-chart").node().clientWidth;

    			var newWidth = newWidther - newMargin.left - newMargin.right;

    			//Change the width of the svg
    			d3.select("svg")
      				.attr("width", newWidth + newMargin.left + newMargin.right);

    			//Change the xScale
    			xScale
    			  .rangeRoundBands([0, newWidth], .25);

    			//Update the bars
    			d3.selectAll("rect")
    			  .attr("x", function(d) { return xScale(d.date); })
    			  .attr("width", xScale.rangeBand() - 5)

    			d3.selectAll("g-label-text")  
    				.attr("x", 20);  

    			//Updates xAxis
    			d3.selectAll(".x.axis")
         			.call(xAxis);   

         		d3.selectAll(".x.axis text")
         		  	.attr("transform", "translate(12, 0)");		

    			//Updates ticks
    			xAxis
     			 .scale(xScale)
     			 .tickValues(xScale.domain().filter(function(d, i) {
     			 	if(d3.select(".gia-chart").node().clientWidth > 410) {
     			 		return !(i % 2);
     			 	}
     			 	else {
     			 		return !(i % 4);
     			 	}
     			 }));

    			//Updates yAxis  
    			d3.selectAll(".y.axis")
      				.call(yAxis); 

    			yAxis
      				.tickSize(-newWidth);
  				};


		}
